module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length) ? _c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                Værdi, salgspris i alt\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.totalValueWithCP)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.ongoingProjects"
    }
  }), _vm._v("\n            Igangværende opgaver\n        ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [(props.column.field == 'case_number') ? _c('span', [_vm._v("\n                    " + _vm._s(props.column.label) + "\n                    "), _c('d-tooltip', {
          attrs: {
            "placement": "inline",
            "identifier": "projects.ongoing.budget"
          }
        })], 1) : _c('span', [_vm._v("\n                    " + _vm._s(props.column.label) + "\n                ")])]
      }
    }, {
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(props.row.status.name) + "\n                    "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                    "), (props.row.minuba_price && props.row.minuba_budget_id) ? _c('minuba-budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), (props.row.minuba_price && props.row.minuba_budget_id && props.row.completion_rate) ? _c('div', {
          staticStyle: {
            "display": "inline-block",
            "position": "relative",
            "height": "8px",
            "width": "50px",
            "background": "#ddd",
            "border-radius": "100px",
            "overflow": "hidden",
            "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
          }
        }, [_c('div', {
          style: (("height:8px;background:" + (props.row.completion_rate > 99 ? '#FF5252' : props.row.completion_rate > 80 ? '#FFA000' : '#4CAF50') + ";width:" + (Math.ceil((50 / 100) * props.row.completion_rate)) + "px;max-width:50px;"))
        }, [_vm._v(" ")])]) : _vm._e()], 1) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description ? props.row.description : '-'
          }
        }, [_vm._v(_vm._s(props.row.description ? props.row.description : '-'))])], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 4223637523)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-320abf01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/projects/ongoing.vue
// module id = 839
// module chunks = 0